<template>
    <div class="card-inteiro">
        <div class="texto-card" @click="$emit('tratarEventoAcessar')">
            <p>
                <strong>Processo:</strong> {{ compra.processo }}
            </p>
            <p>
              <strong>Órgão:</strong> {{ compra.orgao }}
            </p>

            <v-tooltip top>
              <template slot="activator">
                <p class="p-semaforo-situacao">
                  <span :class="'span-semaforo-situacao-compras ' +(compra.situacao === 'ABERTA' ? 'aberta' : 'aguardando-abertura')"></span>
                  {{ compra.dataHoraInicioEnvioPropostas | az-date(humanizarFormatoDataHora(compra.dataHoraInicioEnvioPropostas)) }}
                </p>
              </template>
              Início de envio de proposta
            </v-tooltip>
            <v-tooltip top>
              <template slot="activator">
                <p class="p-semaforo-situacao">
                  <span class="span-semaforo-situacao-compras encerramento"></span>
                  {{ compra.dataHoraEncerramento | az-date(humanizarFormatoDataHora(compra.dataHoraEncerramento)) }}
                </p>
              </template>
              Prazo de encerramento
            </v-tooltip>
            <p>
              <span v-if="compra.tipo === 'COM_DISPUTA'" class="status-compra green">{{ compra.tipo | cdEnum(tiposCompraDireta) }}</span>
              <span v-else class="status-compra grey lighten-1">{{ compra.tipo | cdEnum(tiposCompraDireta )}}</span>
            </p>
          <p :class="'p-indicando-situacao mt-2 darken-1 '+ compra.situacao.toLowerCase()">
            {{ situacoesCompraDireta[compra.situacao]}}
          </p>
        </div>
    </div>
</template>

<script>
import {tiposCompraDireta} from '@/core/constants'
import {situacoesCompraDireta} from '@/core/constants'

export default {
    name: 'ComprasDiretasMeuInteresseCarrosselCard',
    props: ['compra'],
    data() {
        return {
            tiposCompraDireta,
            situacoesCompraDireta
        }
    },
}
</script>

<style scoped lang="stylus">
    .card-inteiro
        width 100%
        display flex
        margin auto 20px
        background-color white
        height 170px
        box-sizing border-box
        transition all .2s ease-in-out

        div[role="listitem"]
            display none

    .icone-situacao
        margin auto 20px

    .texto-card
        color grey
        font-size 12px
        padding 10px 10px 10px 0
        width 100%

    .status-compra
        color #fff
        padding 2px 5px
        border-radius 2px

    .icone-exclusao
        position absolute
        right 0
        z-index 1

        i
            color #bdbdbd

    p.p-semaforo-situacao
        display flex
        align-items center

    span.span-semaforo-situacao-compras
        display inline-block
        height 10px
        width 10px
        border-radius 100%
        margin-right 5px
        box-shadow 1px 1px 1px #dfdfdf

    span.span-semaforo-situacao-compras.aberta
        background-color #4CAF50

    span.span-semaforo-situacao-compras.aguardando-abertura
        background-color #EF8732

    span.span-semaforo-situacao-compras.encerramento
        background-color red

    .p-indicando-situacao
        text-align end

    .p-indicando-situacao.aberta
        color #4CAF50

    .p-indicando-situacao.aguardando_abertura
        color #EF8732
</style>
